/**
 * abnormals service
 */

import Resource from './resource'

export default new Resource('abnormals')



// WEBPACK FOOTER //
// ./src/libraries/services/abnormals.js